import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  MUNILY_NOTIFICATION_CARD_DEFAULT_TYPE,
  MunilyNotificationCardFooter,
  MunilyNotificationCardType,
} from './notification-card.types';

@Component({
  selector: 'common-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationCardComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';

  @Input() leadingIcon: string = 'schedule';
  @Input() iconSet: 'material-symbols-rounded' | 'material-icons' | 'material-icons-outlined' = 'material-symbols-rounded';

  @Input() type: MunilyNotificationCardType = MUNILY_NOTIFICATION_CARD_DEFAULT_TYPE;

  /** Only used when `type === 'toggle'`. */
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;

  @Input() showFooter: boolean = true;
  @Input() footer: MunilyNotificationCardFooter | null = null;

  @Output() select = new EventEmitter<void>();
  @Output() checkedChange = new EventEmitter<boolean>();

  onSelect(): void {
    if (this.disabled) return;
    this.select.emit();
  }

  onToggleChange(next: boolean): void {
    this.checkedChange.emit(next);
  }
}

